import styled from "styled-components"
import {Body} from "@irati/ui/src/Typography"
import {multiLine} from "@irati/ui/src/global/css/multiLineEllipsis"

export default styled(Body).attrs({
  // ellipsis properties
  linesToShow: 2,
  lineHeight: 18
})`
  ${({linesToShow, lineHeight}) => multiLine(linesToShow, lineHeight)}
`
